export type UpdateModalProps = {
  updateType: UpdateType;
};

export enum UpdateType {
  force = 'force',
  prompt = 'prompt',
}
